<template>
  <div class="vendorUsersList">
    <v-content>
      <v-container fluid>
        <center><img class="imgLoader" src="../../shared/assets/images/3dloader.gif" v-if="vendorLoaded == false" /></center>
        <v-flex xs3 searchVendorPanel>
          <div class="relative">
            <a v-if="search != ''" @click.prevent="fncClearSearch" class="searchTypeClear"><i class="material-icons searchTypeClearText">close</i></a>
            <v-text-field @input="fncFilterUsers" v-if="vendorLoaded == true && search != ''" label="Search" solo single-line v-model="search"></v-text-field>
            <v-text-field append-icon="search" @input="fncFilterUsers" v-if="vendorLoaded == true && search == ''" label="Search" solo single-line v-model="search"></v-text-field><br />
          </div>
        </v-flex>
        {{ vendorList  }}
        <v-data-table :headers="headers" v-if="vendorLoaded == true" id="hello" :items="filteredUsers" class="elevation-1 mainTable" hide-actions disable-initial-sort :rows-per-page-items="[2000,40,60,80,100]">
          <template slot="items" slot-scope="props">
            <tr>
              <td width="25%" v-if="props.expanded == true" @click="props.expanded = !props.expanded" ><i v-if="props.item.branch.length > 0 && search == ''" class="material-icons showHide">arrow_downward</i>{{ props.item.label }}</td>
              <td width="25%" v-else @click="props.expanded = !props.expanded" ><i v-if="props.item.branch.length > 0 && search == ''" class="material-icons showHide">arrow_forward</i>{{ props.item.label }}</td>
              <td width="20%" >{{ props.item.vendorName }}</td>
              <td width="20%" >{{ props.item.contactno }}</td>
              <td width="20%" >{{ props.item.email }}</td>
              <td width="10%">
                <v-menu offset-y>
                  <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
                  <v-list>
                    <v-list-tile @click.prevent="fncLinkUsers(props.item.id)">
                      <v-list-tile-title>
                        <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Link Users</a>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click.prevent="fncEditPassword(props.item.id, props.item.email)">
                      <v-list-tile-title>
                        <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Update Password</a>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click.prevent="fncEditNotifications(props.item.id)">
                      <v-list-tile-title>
                        <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Communication Settings</a>
                      </v-list-tile-title>
                    </v-list-tile>
                    <!--<v-list-tile @click.prevent="fncEditStatus(props.item.id)">
                      <v-list-tile-title>
                        <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">User Statuses</a>
                      </v-list-tile-title>
                    </v-list-tile>-->
                    <v-list-tile @click.prevent="fncViewUser(props.item.id, props.item.region)">
                      <v-list-tile-title>
                        <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">User Details</a>
                      </v-list-tile-title>
                    </v-list-tile>

                  </v-list>
                </v-menu>
              </td>
              <td width="5%"  v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncEditUser(props.item)"><i class="material-icons">edit</i></a></td>
              <!--<td width="5%"  v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncDeleteUser(props.item.id, 'user')"><i class="material-icons">delete_forever</i></a></td>-->
            </tr>
          </template>
          <template slot="expand" slot-scope="props">
            <v-data-table v-if="props.item.branch != ''" :headers="headers" :items="props.item.branch" hide-actions class="elevation-1 subTable subTable1" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
              <template slot="items" slot-scope="props">
                <tr>
                  <td width="45%" v-if="props.expanded == true" @click="props.expanded = !props.expanded" ><i v-if="props.item.branch.length > 0" class="material-icons showHide">arrow_downward</i>{{ props.item.label }}</td>
                  <td width="45%" v-else @click="props.expanded = !props.expanded" ><i v-if="props.item.branch.length > 0" class="material-icons showHide">arrow_forward</i>{{ props.item.label }}</td>
                  <td width="20%" >{{ props.item.contactno }}</td>
                  <td width="20%" >{{ props.item.email }}</td>
                  <td width="10%">
                    <v-menu offset-y>
                      <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
                      <v-list>
                        <v-list-tile @click.prevent="fncLinkUsers(props.item.id)">
                          <v-list-tile-title>
                            <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Link Users</a>
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.prevent="fncEditPricelist(props.item.id)">
                          <v-list-tile-title>
                            <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Link User Pricelists</a>
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.prevent="fncEditPassword(props.item.id, props.item.email)">
                          <v-list-tile-title>
                            <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Update Password</a>
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.prevent="fncEditNotifications(props.item.id)">
                          <v-list-tile-title>
                            <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Communication Settings</a>
                          </v-list-tile-title>
                        </v-list-tile>
                        <!--<v-list-tile @click.prevent="fncEditStatus(props.item.id)">
                          <v-list-tile-title>
                            <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">User Statuses</a>
                          </v-list-tile-title>
                        </v-list-tile>-->
                        <v-list-tile @click.prevent="fncViewUser(props.item.id, props.item.region)">
                          <v-list-tile-title>
                            <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">User Details</a>
                          </v-list-tile-title>
                        </v-list-tile>

                      </v-list>
                    </v-menu>
                  </td>
                  <td  width="5%" v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncEditUser(props.item)"><i class="material-icons">edit</i></a></td>
                  <!--<td  width="5%" v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncDeleteUser(props.item.id, 'user')"><i class="material-icons">delete_forever</i></a></td>-->
                </tr>
              </template>
              <template slot="expand" slot-scope="props" class="subTable">
                <v-data-table v-if="props.item.branch != ''" :headers="headers" :items="props.item.branch" hide-actions class="elevation-1 subTable subTable2" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td width="45%" v-if="props.expanded == true" @click="props.expanded = !props.expanded" ><i v-if="props.item.branch.length > 0" class="material-icons showHide">arrow_downward</i>{{ props.item.label }}</td>
                      <td width="45%" v-else @click="props.expanded = !props.expanded" ><i v-if="props.item.branch.length > 0" class="material-icons showHide">arrow_forward</i>{{ props.item.label }}</td>
                      <td width="20%" >{{ props.item.contactno }}</td>
                      <td width="20%" >{{ props.item.email }}</td>
                      <td width="10%">
                        <v-menu offset-y>
                          <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
                          <v-list>
                            <v-list-tile @click.prevent="fncLinkUsers(props.item.id)">
                              <v-list-tile-title>
                                <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Link Users</a>
                              </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click.prevent="fncEditPricelist(props.item.id)">
                              <v-list-tile-title>
                                <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Link User Pricelists</a>
                              </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click.prevent="fncEditPassword(props.item.id, props.item.email)">
                              <v-list-tile-title>
                                <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Update Password</a>
                              </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click.prevent="fncEditNotifications(props.item.id)">
                              <v-list-tile-title>
                                <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Communication Settings</a>
                              </v-list-tile-title>
                            </v-list-tile>
                            <!--<v-list-tile @click.prevent="fncEditStatus(props.item.id)">
                              <v-list-tile-title>
                                <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">User Statuses</a>
                              </v-list-tile-title>
                            </v-list-tile>-->
                            <v-list-tile @click.prevent="fncViewUser(props.item.id, props.item.region)">
                              <v-list-tile-title>
                                <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">User Details</a>
                              </v-list-tile-title>
                            </v-list-tile>

                          </v-list>
                        </v-menu>
                      </td>
                      <td  width="5%" v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncEditUser(props.item)"><i class="material-icons">edit</i></a></td>
                      <!--<td  width="5%" v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncDeleteUser(props.item.id, 'user')"><i class="material-icons">delete_forever</i></a></td>-->
                    </tr>
                  </template>
                  <template slot="expand" slot-scope="props">
                    <v-data-table v-if="props.item.branch != ''" :items="props.item.branch" hide-actions class="elevation-1 subTable subTable3" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                      <template slot="items" slot-scope="props">
                        <tr>
                          <td width="45%" v-if="props.expanded == true" @click="props.expanded = !props.expanded" ><i v-if="props.item.branch.length > 0" class="material-icons showHide">arrow_downward</i>{{ props.item.label }}</td>
                          <td width="45%" v-else @click="props.expanded = !props.expanded" ><i v-if="props.item.branch.length > 0" class="material-icons showHide">arrow_forward</i>{{ props.item.label }}</td>
                          <td width="20%" >{{ props.item.contactno }}</td>
                          <td width="20%" >{{ props.item.email }}</td>
                          <td width="10%">
                            <v-menu offset-y>
                              <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
                              <v-list>
                                <v-list-tile @click.prevent="fncLinkUsers(props.item.id)">
                                  <v-list-tile-title>
                                    <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Link Users</a>
                                  </v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile @click.prevent="fncEditPricelist(props.item.id)">
                                  <v-list-tile-title>
                                    <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Link User Pricelists</a>
                                  </v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile @click.prevent="fncEditPassword(props.item.id, props.item.email)">
                                  <v-list-tile-title>
                                    <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Update Password</a>
                                  </v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile @click.prevent="fncEditNotifications(props.item.id)">
                                  <v-list-tile-title>
                                    <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Communication Settings</a>
                                  </v-list-tile-title>
                                </v-list-tile>
                                <!--<v-list-tile @click.prevent="fncEditStatus(props.item.id)">
                                  <v-list-tile-title>
                                    <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">User Statuses</a>
                                  </v-list-tile-title>
                                </v-list-tile>-->
                                <v-list-tile @click.prevent="fncViewUser(props.item.id, props.item.region)">
                                  <v-list-tile-title>
                                    <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">User Details</a>
                                  </v-list-tile-title>
                                </v-list-tile>
                              </v-list>
                            </v-menu>
                          </td>
                          <td  width="5%" v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncEditUser(props.item)"><i class="material-icons">edit</i></a></td>
                          <!--<td  width="5%" v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncDeleteUser(props.item.id, 'user')"><i class="material-icons">delete_forever</i></a></td>-->
                        </tr>
                      </template>
                      <template slot="expand" slot-scope="props">
                        <v-data-table v-if="props.item.branch != ''" :items="props.item.branch" hide-actions class="elevation-1 subTable subTable4" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                          <template slot="items" slot-scope="props">
                            <tr>
                              <td width="45%" v-if="props.expanded == true" @click="props.expanded = !props.expanded" ><i v-if="props.item.branch.length > 0" class="material-icons showHide">arrow_downward</i>{{ props.item.label }}</td>
                              <td width="45%" v-else @click="props.expanded = !props.expanded" ><i v-if="props.item.branch.length > 0" class="material-icons showHide">arrow_forward</i>{{ props.item.label }}</td>
                              <td width="20%" >{{ props.item.contactno }}</td>
                              <td width="20%" >{{ props.item.email }}</td>
                              <td width="10%">
                                <v-menu offset-y>
                                  <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
                                  <v-list>
                                    <v-list-tile @click.prevent="fncLinkUsers(props.item.id)">
                                      <v-list-tile-title>
                                        <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Link Users</a>
                                      </v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click.prevent="fncEditPricelist(props.item.id)">
                                      <v-list-tile-title>
                                        <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Link User Pricelists</a>
                                      </v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click.prevent="fncEditPassword(props.item.id, props.item.email)">
                                      <v-list-tile-title>
                                        <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Update Password</a>
                                      </v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click.prevent="fncEditNotifications(props.item.id)">
                                      <v-list-tile-title>
                                        <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Communication Settings</a>
                                      </v-list-tile-title>
                                    </v-list-tile>
                                    <!--<v-list-tile @click.prevent="fncEditStatus(props.item.id)">
                                      <v-list-tile-title>
                                        <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">User Statuses</a>
                                      </v-list-tile-title>
                                    </v-list-tile>-->
                                    <v-list-tile @click.prevent="fncViewUser(props.item.id, props.item.region)">
                                      <v-list-tile-title>
                                        <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">User Details</a>
                                      </v-list-tile-title>
                                    </v-list-tile>

                                  </v-list>
                                </v-menu>
                              </td>
                              <td  width="5%" v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncEditUser(props.item)"><i class="material-icons">edit</i></a></td>
                              <!--<td  width="5%" v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncDeleteUser(props.item.id, 'user')"><i class="material-icons">delete_forever</i></a></td>-->
                            </tr>
                          </template>
                          <template slot="expand" slot-scope="props">
                            <v-data-table v-if="props.item.branch != ''" :items="props.item.branch" hide-actions class="elevation-1 subTable subTable5" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                              <template slot="items" slot-scope="props">
                                <tr>
                                  <td width="45%" v-if="props.expanded == true" @click="props.expanded = !props.expanded" ><i v-if="props.item.branch.length > 0" class="material-icons showHide">arrow_downward</i>{{ props.item.label }}</td>
                                  <td width="45%" v-else @click="props.expanded = !props.expanded" ><i v-if="props.item.branch.length > 0" class="material-icons showHide">arrow_forward</i>{{ props.item.label }}</td>
                                  <td width="20%" >{{ props.item.contactno }}</td>
                                  <td width="20%" >{{ props.item.email }}</td>
                                  <td width="10%">
                                    <v-menu offset-y>
                                      <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
                                      <v-list>
                                        <v-list-tile @click.prevent="fncLinkUsers(props.item.id)">
                                          <v-list-tile-title>
                                            <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Link Users</a>
                                          </v-list-tile-title>
                                        </v-list-tile>
                                        <v-list-tile @click.prevent="fncEditPricelist(props.item.id)">
                                          <v-list-tile-title>
                                            <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Link User Pricelists</a>
                                          </v-list-tile-title>
                                        </v-list-tile>
                                        <v-list-tile @click.prevent="fncEditPassword(props.item.id, props.item.email)">
                                          <v-list-tile-title>
                                            <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Update Password</a>
                                          </v-list-tile-title>
                                        </v-list-tile>
                                        <v-list-tile @click.prevent="fncEditNotifications(props.item.id)">
                                          <v-list-tile-title>
                                            <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Communication Settings</a>
                                          </v-list-tile-title>
                                        </v-list-tile>
                                        <!--<v-list-tile @click.prevent="fncEditStatus(props.item.id)">
                                          <v-list-tile-title>
                                            <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">User Statuses</a>
                                          </v-list-tile-title>
                                        </v-list-tile>-->
                                        <v-list-tile @click.prevent="fncViewUser(props.item.id, props.item.region)">
                                          <v-list-tile-title>
                                            <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">User Details</a>
                                          </v-list-tile-title>
                                        </v-list-tile>

                                      </v-list>
                                    </v-menu>
                                  </td>
                                  <td  width="5%" v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncEditUser(props.item)"><i class="material-icons">edit</i></a></td>
                                  <!--<td  width="5%" v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncDeleteUser(props.item.id, 'user')"><i class="material-icons">delete_forever</i></a></td>-->
                                </tr>
                              </template>
                            </v-data-table>
                          </template>
                        </v-data-table>
                      </template>
                    </v-data-table>
                  </template>
                </v-data-table>
              </template>
            </v-data-table>
          </template>
        </v-data-table>
      </v-container>
    </v-content>
    <!--<modal></modal>-->
  </div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import Modal from '@/components/shared/modal';

  export default {
    name: 'UserList',
    intRoleEdit: 0,
    data() {
      return {
        search: '',
        filteredUsers: [],
        headers: [
          { text: 'Full Name', value: 'name', width: '25%' },
          { text: 'Vendor', value: 'name', width: '20%' },
          { text: 'Contact No', value: 'registration_no', width: '20%' },
          { text: 'Email Address', value: 'email', width: '20%' },
          { text: 'User Actions', value: 'actions', width: '10%' },
          { text: 'Edit', value: 'edit', width: '5%' }
          /*{ text: 'Delete', value: 'delete', width: '5%' }*/
        ]
      }
    },
    methods: {
      fncClearSearch() {
        this.search = '';
        this.fncFilterUsers();
      },
      fncFilterUsers() {
        this.$store.commit({
          type: 'fncFilterUsers',
          search: this.search,
          uType: 'vendor'
        })
      },
      fncDeleteUser(userId, type) {
        var deleteUser = confirm('Are you sure you want to delete this user?');
        if (deleteUser === true) {
          this.$store.dispatch({
            type: 'fncDeleteUser',
            userId: userId,
            context: 6,
            deleteType: type
          })
        }
      },
      fncEditNotifications(userId) {
        this.$store.dispatch({
          type: 'fncSetUserNotifications',
          userId: userId,
          context: 6
        })
        var modalDetails = { title: 'Communication Settings', component: 'modal-user-notifications', mstate: true, params: { userId: userId } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncEditPassword(userId, userEmail) {
        var updatePassword = confirm('Are you sure you want to update the users password?');
        if (updatePassword === true) {
          this.$store.dispatch({
            type: 'fncUpdateUserPassword',
            userId: userId,
            userEmail: userEmail
          })
        }
      },
      fncEditPricelist(userId) {
        this.$store.dispatch({
          type: 'fncEditUserPricelist',
          userId: userId
        })
      },
      fncEditStatus(userId) {
        this.$store.dispatch({
          type: 'fncEditStatus',
          userId: userId,
          status: 'quote'

        })
      },
      fncLinkUsers(userId) {
        this.$store.commit('fncEmptyUserLinks');
        var modalDetails = { title: 'Link Users', component: 'modal-user-link', mstate: true, params: { userId: userId, userType: 6 } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncEditUser(user) {
        this.$store.dispatch('fncSetEditUser', user);
        this.$store.dispatch('fncPopulateUserRegions');
        this.$store.dispatch('fncPopulateUserVendors');
        this.$store.dispatch('fncSetupUserCreate', '');
      },
      fncViewUser(userId, regions) {
        this.$store.dispatch({
          type: 'fncViewUser',
          userId: userId,
          regions: regions
        })
      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'vendorUsers',
        'vendorUserSearch',
        'vendorLoaded'
      ])
    },
    beforeMount() {
      this.$store.dispatch({
        type: 'fncPopulateUsers',
        context: 6
      });
    },
    watch: {
      vendorUsers() {
        this.filteredUsers = this.vendorUsers;
      },
      vendorUserSearch() {
        if (this.search == '') {
          this.filteredUsers = this.vendorUsers;
        } else {
          this.filteredUsers = this.vendorUserSearch;
        }
      }
    }
  }
</script>

<style scoped>
  @import '../../shared/assets/css/shared.css'
</style>
